<script>
	import Portal from 'svelte-portal';
    
	export let panelItems = '', lang = 'en', closePanel = '', cartData = '', cartSummary={}, addDataLayer = '', promotionData = {}, panelType = 'cart', cartPanelLoading = false, storeSceneEnabled=false, isLoyaltyEligibleItem = false, sceneSubtotal = 0;

    const en = lang != 'fr';

    const Strings = en ? {
        'orderSummary': qty => `Subtotal (${qty} ${qty > 1 ? 'Items' : 'Item'})`,
        'salePrice' : (price, salePrice) => `<strong>$${salePrice?.toFixed(2)}/EA</strong> was $${price?.toFixed(2)}/EA`,
        'cardLinkedSceneText': 'Earn 50 Scene+ points for every $50 spent on eligible purchases (pre-tax)',
        'cardNotLinkedSceneText': 'Add your Scene+ card to earn points on orders over $50 (pre-tax)',
        "loyaltyCopyCart1": "Earn Scene+<sup class='Trademark'>TM</sup> points on orders over $50 (pre-tax).",
        "loyaltyCopyCart2": "Don't forget to add your Scene+<sup class='Trademark'>TM</sup> card at checkout to earn points.",
        "creditCopy": "<strong>Earn 2X the Scene+<sup class='Trademark'>TM</sup> points</strong><br>For every $1 spent on eligible purchases with the <strong>Scotiabank\u00AE Scene+<sup class='Trademark'>TM</sup> Visa* Card.</strong>",
        "conditions1": "*Offer available at all Home Hardware stores. Scene+<sup class='Trademark'>TM</sup> members will earn 50 points for every increment of $50.00 spent on the purchase of qualifying products and services in a single transaction, (excluding taxes, delivery charges and excluded services). Purchases made by Pro Contractors, as defined by Home Hardware stores, are not eligible to earn Scene+ points on commercial purchases using the Black Scene+ loyalty card.",
        "conditions2": "**Applies to eligible purchases only at Home Hardware, Home Building Centre, Home Hardware Building Centre, Home Furniture locations in Canada and online at homehardware.ca. Conditions apply.",
    } : {
        'orderSummary': qty => `Sous-total (${qty} ${qty > 1 ? 'Objets' : 'Objet'})`,
        'salePrice' : (price, salePrice) => `<strong>$${salePrice?.toFixed(2)}/CH $</strong> était ${price?.toFixed(2)}/CH $`,
        'cardLinkedSceneText': 'Obtenez 50 points Scène+ pour chaque 50 $ dépensés sur les achats admissibles (avant taxes) ',
        'cardNotLinkedSceneText': 'Ajoutez votre carte Scène+ pour accumuler des points sur les commandes de plus de 50 $ (avant taxes) ',
        "loyaltyCopyCart1": "Accumulez des points Scène+<sup class='Trademark'>MC</sup> sur les commandes de plus de 50 $ (avant taxes).",
        "loyaltyCopyCart2": "N'oubliez pas d'ajouter votre carte Scène+<sup class='Trademark'>MC</sup> au moment du paiement pour accumuler des points.",
        "creditCopy": "<strong>Accumulez 2X les points Scènes+<sup class='Trademark'>MC</sup></strong><br>Pour chaque 1 $ dépensé sur des achats admissibles avec la Carte <strong>Visa* Scène+<sup class='Trademark'>MC</sup> Banque Scotia<sup class='Trademark'>MD</sup>.</strong>",
        "conditions1": "*Offre valable dans tous les magasins Home. Les membres Scène+<sup class='Trademark'>MC</sup> obtiendront 50 points par tranche de 50 $ de produits et services admissibles achetés dans une seule transaction (sans taxes, frais de livraison et services exclus). Les entrepreneurs PRO, tels que définis par les magasins Home Hardware, ne peuvent pas accumuler des points Scène+ sur les achats commerciaux faits avec la carte de fidélité Scène+ noire.",
        "conditions2": "**S'applique aux achats admissibles seulement dans les magasins Home Hardware, Centre de rénovation Home, Centre de rénovation Home Hardware et Home Furniture au Canada, et en ligne sur le site homehardware.ca. Des conditions s'appliquent.",        
    };
    

    function slugify(str) {
        return str?.toLowerCase()?.replace(/\//g, '')?.replace(/[^a-z0-9]/g, ' ')?.trim()?.replace(/\s+/g, '-') || '';
    }

    function checkoutSubmit(e) {
        if (cartData?.id) {
            window.localStorage.checkout_from_flyer = true;
            addDataLayer('Checkout');
            e.target.submit();
        }
    }
</script>

<Portal target="hh-panel">
    <header>
        {#if panelType == 'cart'}
            <div class="my-cart">
                <img src={"https://homehardware.sirv.com/hh/icons/icon-my-cart.svg"} alt="{en ? "My Cart" : "Mon panier"} Icon" width="22" height="19">
                <a on:click={() => addDataLayer("View Cart")} href="/{lang}/cart">
                    <h3>{en ? "My Cart" : "Mon panier"}</h3>
                </a>
            </div>
        {:else}
            <div class="added-to-cart">
                <img src={"https://homehardware.sirv.com/hh/icons/hh-tick-green.svg"} alt="{en ? 'Added to Cart' : 'Ajouté au panier'} Icon" width="22" height="22">
                <h3>{en ? 'Added to Cart' : 'Ajouté au panier'}</h3>
            </div>
        {/if}
        <button class="Button ButtonGhost" on:click|preventDefault={closePanel}>{en ? 'Close' : 'Fermer'}</button>
    </header>
    {#if panelType == 'cart' && cartPanelLoading}
        <section class="Center">
            <img src="/_assets/svg/loader.svg" alt="loading" class="Icon" height="0" width="0" /> 
            {en ? "Fetching your cart data" : "Récupérer les données de votre panier"}
        </section>
    {:else}
        <div class="cart-messages">
            {#if promotionData.cartPromotion}
                {@html promotionData.cartPromotion}
            {/if}
            {#if promotionData.thresholdStatus}
                <p>
                    <img src={"https://homehardware.sirv.com/hh/icons/icon-shipping-truck.svg"} alt="Shipping Truck Icon" width="15" height="12">
                    {#if promotionData.thresholdAmount <= 0}
                        {en ? 'Your order has qualified for free delivery' : 'Votre commande s\'est qualifiée pour la livraison gratuite'}
                    {:else}
                        {en ? 'You\'re' : 'Vous êtes à'} ${promotionData.thresholdAmount} {en ? 'away from free delivery' : 'de la livraison gratuite'}
                    {/if}
                </p>
            {/if} 
        </div>
        {#if panelType == 'cart' && panelItems.length === 0}
            <section class="Center">
                <h4 data-no-cart>{en ? "You don't have anything in your cart yet" : "Vous n'avez rien dans votre panier encore"}</h4>
            </section>
            {/if}
        <section class="product-list">
            {#each panelItems as item}
                <section class="cart-item">
                    <a class="product-image" href="/{lang}/{slugify(item.product?.name)}/p/{item.product?.productCode}">
                        <img src="https://homehardware.sirv.com/products/{item.product?.productCode?.slice(0,4)}/{item.product?.productCode}.view?thumb=image&width=200"
                            alt={item.product?.name}
                            onerror={`this.src="https://homehardware.sirv.com/hh/icons/Icon_150x150_ImageComingSoon.grey.${lang}.svg"`} />
                    </a>
                    <div class="product-data">
                          {#if item?.isLockedInLowPrice}
                              <img src={`https://homehardware.sirv.com/hh/icons/LockedInLowPrice_${lang === 'fr' ? 'FR_' : ''}x50.svg`} alt="Locked-In-Price Logo" width="60" height="34" />
                          {:else}
                          {#if item?.isOnlineClearance}
                                <span class="clearance-badge">{en ? 'ONLINE CLEARANCE' : 'LIQUIDATION EN LIGNE'}</span>
                          {:else if item?.isSaleItem}
                                <span class="sale-badge">{en ? 'SALE' : 'VENTE'}</span>
                          {/if}
                        {/if}

                        <a href="/{lang}/{slugify(item.product?.name)}/p/{item.product?.productCode}">
                            <p>{item.product?.name}</p>
                        </a>
                        <p>#{item.product?.productCode}</p>
                        <p><strong>{en ? 'Qty' : 'Qté'}: {item.quantity}</strong></p>
                        <p><strong>{@html item.product?.price?.salePrice ? Strings.salePrice(item.product?.price?.price, item.product?.price?.salePrice) : `$${item.total?.toFixed(2)}`}</strong></p>
                    </div>
                </section>
            {/each}
        </section>
    {/if}
    {#if panelItems.length}
        <section class="cart-summary">
            {#if panelType == 'cart'}
                <strong>
                    <p class="cart-order-summary">
                        <span>{Strings.orderSummary(cartSummary.totalQuantity)}</span>
                        <span>${cartData?.total?.toFixed(2)}</span>
                    </p>    
                </strong>
            {/if}

            <form class="Center cart-buttons" method="post" action="/{lang}/cart/checkout" on:submit|preventDefault={checkoutSubmit}>
                <input type="hidden" name="id" value="{cartData?.id}" />
                <a on:click={() => addDataLayer('View Cart')} href="/{lang}/cart" data-lang="{lang}" class="Button ButtonSecondary ButtonBlock">{en ? 'View Cart' : 'Voir le panier'}</a>
                <button type="submit" class="Button ButtonBlock">{en ? 'Checkout' : 'Passer à la caisse'}</button>
            </form>

        </section>
        <!-- {#if panelType == 'cart' && showLoyaltyService && storeSceneEnabled && isLoyaltyEligibleItem}
            <div class="loyalty-marketing">
                <img id="scene" src="https://homehardware.sirv.com/hh/Loyalty/Icon_Scene.{lang}.black.svg" alt="scene" height="30" width="90" />
                <p>{userLoyaltyEnabled ? Strings.cardLinkedSceneText : Strings.cardNotLinkedSceneText}</p>   
            </div>
        {/if} -->
        {#if panelType == 'cart' && storeSceneEnabled && isLoyaltyEligibleItem}
            <section class="SceneBuyabilityContainer">
                <section>
                    <figure>
                        <div class="Earn">
                            <img src="https://homehardware.sirv.com/hh/Loyalty/Scene_Plus_Vertical_ENG-Sqr.png" alt="Scene Card" />
                        </div>
                    </figure>
                    <aside>
                        {#if sceneSubtotal < 50}
                            <small><strong>{@html Strings.loyaltyCopyCart1}</strong></small><br>
                        {:else}
                            <small><strong>{@html Strings.loyaltyCopyCart2}</strong></small><br>
                        {/if}
                        <small>{lang == "en" ? "Conditions apply." : "Des conditions s'appliquent."} <a href="https://www.homehardware.ca/{lang}/landing/sceneplus" target="_blank" rel="nofollow" class="Underline">{lang == "en" ? "Learn more." : " En savoir plus."}</a>*</small>
                    </aside>
                </section>
                <section>
                    <figure>
                        <div class="Credit">
                            <img src="https://homehardware.sirv.com/hh/Loyalty/Scene_Plus_Horizontal_ENG-Sqr.png" alt="Scene Card" />
                        </div>
                    </figure>
                    <aside>
                        <small>{@html Strings.creditCopy}</small><br>
                        <small>{lang == "en" ? "Conditions apply." : "Des conditions s'appliquent."} <a href="https://www.homehardware.ca/{lang}/landing/scotiabank-scene-visa" target="_blank" rel="nofollow" class="Underline">{lang == "en" ? "Learn more." : " En savoir plus."}</a>**</small>
                    </aside>
                </section>
            </section>
            <section class="Conditions">
                <small>{@html Strings.conditions1}<br>{@html Strings.conditions2}</small>
            </section>
        {/if}
        
    {/if}
    
    {#if panelType == 'addToCart'}
        <!-- <hh-recs pageType="product" productCode={panelItems[0]?.product?.productCode} component="relatedProducts" title={en ? 'Recommended for you' : 'Recommandé pour vous'} cardStyle="vertical" data-list="addToCartFlyoutProducts"></hh-recs> -->
        {@html `<hh-product-recs type="related" data-list="addToCartFlyoutProducts" cardstyle="vertical" products="${panelItems[0]?.product?.productCode}" headline="${en ? 'Recommended For You' : 'Recommandé pour vous'}"></hh-product-recs>`}
    {/if}
</Portal>

<style>
    Header > .my-cart {
        display: flex;
        align-items: center;
        column-gap: calc(var(--gap) / 2);
    }
    Header > .my-cart a {
        text-decoration: underline;
        text-underline-position: under;
    }
    Header > .added-to-cart {
        display: flex;
        column-gap: calc(var(--gap) / 2);
    }

    h4[data-no-cart] {
        display: inline-block;
        width: 12.5em;
    }

	.cart-messages {
		align-items: center;
		/* width: 100%; REMOVED TO IMPROVE PADDING - RB */
		background: #EFF0F0;
		text-align: center;
		padding: calc(var(--gap) / 2) var(--gap) !important;		
	}
	.cart-messages > :global(p) {
		padding: 0;
	}

    .product-list {
        padding: 0 var(--gap) 0 !important;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .cart-item {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        column-gap: var(--gap);
        border-bottom: 1px solid var(--hh-grey);
        padding: 1em 0 0.25em;
    }
    .cart-item:last-child {
        border-bottom: none;
    }
    .product-image > img{
        height: 105px;
        width: 105px;
        object-fit: contain;
        object-position: center;
    }
    .product-data {
        display: flex;
        flex-direction: column;
    }
    .product-data p {
        line-height: 20px;
        padding: 0;
        margin: 0;      
    }
    .product-data > p:nth-of-type(2) {
        flex-grow: 1;
    }
    .product-data > p:last-child {
        text-align: right;
    }
    .product-data > a > p:hover {
        text-decoration: underline;
    }
    .clearance-badge,
    .sale-badge {
        display: inline-block;
        font-family: "hhAgendaBold", sans-serif;
        padding:  0.05em 1.1em;
        font-size: .875em;
        margin-bottom: 0.5em;
        align-self: flex-start;
    }
    .clearance-badge {
        background-color: #ffd100;
    }
    .sale-badge {
        color: #ffffff;
        background-color: #D6001C;
    }

    .cart-summary {
        display: grid;
        grid-auto-flow: row;
        /* grid-gap: calc(var(--gap) / 2); */
        /* padding-top: 0 !important; */
        position: sticky;
        position: -webkit-sticky;
        background-color: rgb(255, 255, 255);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        bottom: 0;
    }
    .cart-order-summary {
        display: flex;
    }
    .cart-order-summary > *:first-child {
        flex-grow: 1
    }
    .cart-buttons > a {
        margin-bottom: 0.8em;
        text-decoration: none;
    }
    /* NEW LOYALTY GRID LAYOUT */
    /* .loyalty-marketing {
        display: grid;
        grid-template-columns: 1fr 3fr;
        box-shadow: 0 0 0 1px #0003 inset;
        padding: 0;
    }
    .loyalty-marketing p {
        font-family: "hhAgendaBold";
        line-height: 1.2;
        background: var(--hh-black);
        color: var(--hh-white);
        padding: calc(var(--gap) / 3) var(--gap);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    img#scene {
        align-self: center;
        justify-self: center;
        margin-bottom: 4px;
        padding: calc(var(--gap) / 2);
        max-width: 70%;
        min-width: 75px;
    } */
      .SceneBuyabilityContainer {
		display: grid;
		grid-template-columns: 1fr;
		grid-gap: 1em;
		border-radius: 6px;
		overflow: hidden;
		margin-bottom: 2rem;
		line-height: 1.3;
	}
	.SceneBuyabilityContainer > section {
		display: flex;
		flex-direction: row;
		border-radius: 6px;
		overflow: hidden;
		background: url('https://homehardware.sirv.com/hh/icons/Icon_SceneDots.svg') no-repeat 101% -3%, var(--hh-light-grey);
		background-size: 9%;
		box-shadow: 0 0 0 1px #0001 inset, 0 1rem 2rem -1rem #eeeeee;
	}
	.SceneBuyabilityContainer > section > figure {
		background: black;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-block: calc(var(--gap) / 4);
		margin: 0;
	}
	.SceneBuyabilityContainer > section > figure > div {
		padding: 0.75em;
		margin: 0 -2.5em 0 -0.5em;
		border-radius: 50%;	
		aspect-ratio: 1/1;
	}
	.SceneBuyabilityContainer > section > figure > div.Earn {
		background: #903BFF;
	}
	.SceneBuyabilityContainer > section > figure > div.Credit {
		background: #FF343F;
	}
	.SceneBuyabilityContainer > section > figure > div img {
		max-height: 3.5em;
		display: flex;
	}
	.SceneBuyabilityContainer > section > aside {
		padding: 1em 3.25em;
	}
</style>
